import ApiClientFactory from '../../../api/client-factory';
import { SettingsApiAccountService } from './service';

const service = new SettingsApiAccountService(ApiClientFactory());

export function SettingsApiAccountServiceFactory(): typeof service {
  return service;
}
